export const AUTH_STORAGE_KEY = 'superior_crm_auth_user'

export const LOGIN_STEPS = {
  EMAIL: 'email',
  OTP: 'otp',
}
